import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { GrupoListarModule } from './grupo-listar/grupo-listar.module';
import { GrupoInserirModule } from './grupo-inserir/grupo-inserir.module'; 
import { GrupoDetalharModule } from './grupo-detalhar/grupo-detalhar.module';
import { GrupoEditarModule } from './grupo-editar/grupo-editar.module';

@NgModule({
    imports: [RouterModule.forChild([        
        { path: '', data: { breadcrumb : '' }, loadChildren: () => GrupoListarModule },        
        { path: 'inserir', data: { breadcrumb : 'Novo' }, loadChildren: () => GrupoInserirModule },
        { path: 'detalhar', data: { breadcrumb : 'Detalhar' }, loadChildren: () => GrupoDetalharModule },
        { path: 'editar', data: { breadcrumb : 'Editar' }, loadChildren: () => GrupoEditarModule }       


    ])],
    exports: [RouterModule]
})
export class GrupoAppRoutingModule { }